import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*@__PURE__*/_defineComponent({
  __name: 'ContentMaxWidth',
  props: {
    width: {
        type: Number,
        default: 1200,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ 'max-width': __props.width + 'px' }),
    class: "mx-auto"
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 4))
}
}

})